import { Component } from 'react';
import HoldingLayout from './HoldingLayout';

class ThemedTOS extends Component {
  render() {
    return (
      <HoldingLayout>
        <section className="h-page-hero h-page-hero-sm">
          <div className="h-hero-bg-pattern" aria-hidden="true" />
          <div className="h-section-inner">
            <div className="h-page-hero-content">
              <h1 className="h-page-hero-title">Terms of Service</h1>
              <p className="h-page-hero-desc">Last updated: August 6th, 2025</p>
            </div>
          </div>
        </section>
        <section className="h-page-prose">
          <div className="h-section-inner">
            <div className="h-prose-content">
              <p>
                These Terms of Service ("Terms") govern your access to and use of our website located at{' '}
                <a href="https://www.rakeen.cc" target="_blank" rel="noopener noreferrer">https://www.rakeen.cc</a>{' '}
                and the services provided by Rakeen ("Rakeen", "we", "us", or "our").
              </p>

              <h2>1. Purpose of the Website</h2>
              <p>
                This website is operated by Rakeen, a technology company based in Khobar, Saudi Arabia. Rakeen provides digital marketing and CRM solutions, smart correspondence management, and other business software products. Our services include advertising campaign management across platforms such as TikTok and Snapchat, customer relationship management tools, analytics and reporting, document management, and ad landing pages with lead attribution.
              </p>

              <h2>2. Acceptance of Terms</h2>
              <p>
                By accessing or using our website, you agree to be bound by these Terms and our{' '}
                <a href="/privacy">Privacy Policy</a>.
              </p>

              <h2>3. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos, and software, is the property of Rakeen or its licensors and is protected by applicable copyright and trademark laws.
              </p>

              <h2>4. Use Restrictions</h2>
              <p>
                You agree not to misuse the site, including attempting to gain unauthorized access, interfering with service operations, or transmitting malicious code.
              </p>

              <h2>5. Disclaimer</h2>
              <p>
                All content and functionality on the site are provided "as is" without warranty of any kind. We do not guarantee that the site will be error-free or uninterrupted.
              </p>

              <h2>6. Limitation of Liability</h2>
              <p>
                In no event shall Rakeen be liable for any indirect, incidental, or consequential damages arising from your use of the site or reliance on its content.
              </p>

              <h2>7. Modifications</h2>
              <p>
                We reserve the right to update or modify these Terms at any time without prior notice. Updates will be effective upon posting on this page.
              </p>

              <h2>8. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the Kingdom of Saudi Arabia.
              </p>

              <h2>9. Contact Us</h2>
              <p>If you have any questions about these Terms, you can contact us:</p>
              <ul>
                <li>By email: <a href="mailto:info@rakeen.cc">info@rakeen.cc</a></li>
                <li>By visiting our <a href="/contact">contact page</a></li>
              </ul>
            </div>
          </div>
        </section>
      </HoldingLayout>
    );
  }
}

export default ThemedTOS;
